/* tslint:disable */
/* eslint-disable */
/**
 * GroupManage API
 * グループ情報を操作する
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface CreateBulkOrderRequest
 */
export interface CreateBulkOrderRequest {
    /**
     * 
     * @type {Array<OrderInfoForBulkOrderInfo>}
     * @memberof CreateBulkOrderRequest
     */
    'orderInfoForBulkOrder': Array<OrderInfoForBulkOrderInfo>;
    /**
     * 
     * @type {Array<CreateBulkOrderRequestOrderBasisAdjustmentsInner>}
     * @memberof CreateBulkOrderRequest
     */
    'orderBasisAdjustments': Array<CreateBulkOrderRequestOrderBasisAdjustmentsInner>;
    /**
     * まとめ発注グループ名
     * @type {string}
     * @memberof CreateBulkOrderRequest
     */
    'orderGroupName': string;
    /**
     * 請求書番号
     * @type {string}
     * @memberof CreateBulkOrderRequest
     */
    'invoiceNumber'?: string;
    /**
     * 上限数量
     * @type {number}
     * @memberof CreateBulkOrderRequest
     */
    'upperLimitQuantity': number;
    /**
     * 仕向先名
     * @type {string}
     * @memberof CreateBulkOrderRequest
     */
    'destinationName'?: string;
    /**
     * メモ
     * @type {string}
     * @memberof CreateBulkOrderRequest
     */
    'memo'?: string;
}
/**
 * 
 * @export
 * @interface CreateBulkOrderRequestOrderBasisAdjustmentsInner
 */
export interface CreateBulkOrderRequestOrderBasisAdjustmentsInner {
    /**
     * 
     * @type {string}
     * @memberof CreateBulkOrderRequestOrderBasisAdjustmentsInner
     */
    'aggregateBusinessId': string;
    /**
     * 
     * @type {OrderBasisAdjustedInfo}
     * @memberof CreateBulkOrderRequestOrderBasisAdjustmentsInner
     */
    'adjustment': OrderBasisAdjustedInfo;
}
/**
 * まとめ発注作成のレスポンス
 * @export
 * @interface CreateBulkOrderResponse
 */
export interface CreateBulkOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof CreateBulkOrderResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof CreateBulkOrderResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof CreateBulkOrderResponse
     */
    'message': string;
    /**
     * 
     * @type {CreateBulkOrderResponseInfo}
     * @memberof CreateBulkOrderResponse
     */
    'result': CreateBulkOrderResponseInfo;
}
/**
 * 
 * @export
 * @interface CreateBulkOrderResponseDataInner
 */
export interface CreateBulkOrderResponseDataInner {
    /**
     * 表示ID
     * @type {string}
     * @memberof CreateBulkOrderResponseDataInner
     */
    'displayId': string;
    /**
     * 発注ID
     * @type {string}
     * @memberof CreateBulkOrderResponseDataInner
     */
    'orderId': string;
    /**
     * 集計ID
     * @type {string}
     * @memberof CreateBulkOrderResponseDataInner
     */
    'aggregateBusinessId': string;
    /**
     * 推奨発注日 (推奨発注の時はnull)
     * @type {number}
     * @memberof CreateBulkOrderResponseDataInner
     */
    'recommendCreatedOrderDate'?: number;
    /**
     * 推奨納入日 (推奨発注の時はnull)
     * @type {number}
     * @memberof CreateBulkOrderResponseDataInner
     */
    'recommendEstimateTime'?: number;
    /**
     * 推奨発注数量 (推奨発注の時はnull)
     * @type {number}
     * @memberof CreateBulkOrderResponseDataInner
     */
    'recommendArrivalValue'?: number;
}
/**
 * まとめ発注作成のレスポンス
 * @export
 * @interface CreateBulkOrderResponseInfo
 */
export interface CreateBulkOrderResponseInfo {
    /**
     * まとめ発注作成のレスポンスの中身
     * @type {Array<CreateBulkOrderResponseDataInner>}
     * @memberof CreateBulkOrderResponseInfo
     */
    'data': Array<CreateBulkOrderResponseDataInner>;
}
/**
 * 発注グループから発注を削除する情報
 * @export
 * @interface DeleteOrderFromOrderGroupInfo
 */
export interface DeleteOrderFromOrderGroupInfo {
    /**
     * 発注グループID
     * @type {string}
     * @memberof DeleteOrderFromOrderGroupInfo
     */
    'orderGroupId': string;
    /**
     * 発注IDのリスト
     * @type {Array<string>}
     * @memberof DeleteOrderFromOrderGroupInfo
     */
    'orderIds': Array<string>;
}
/**
 * 発注グループから発注を削除するAPIのレスポンス
 * @export
 * @interface DeleteOrderFromOrderGroupResponse
 */
export interface DeleteOrderFromOrderGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteOrderFromOrderGroupResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof DeleteOrderFromOrderGroupResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof DeleteOrderFromOrderGroupResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof DeleteOrderFromOrderGroupResponse
     */
    'result': object;
}
/**
 * 発注グループ情報削除レスポンスで返す情報
 * @export
 * @interface DeleteOrderGroupResponse
 */
export interface DeleteOrderGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteOrderGroupResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof DeleteOrderGroupResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof DeleteOrderGroupResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof DeleteOrderGroupResponse
     */
    'result': object;
}
/**
 * 
 * @export
 * @interface DeleteOrderToOrderGroupRequest
 */
export interface DeleteOrderToOrderGroupRequest {
    /**
     * 
     * @type {DeleteOrderFromOrderGroupInfo}
     * @memberof DeleteOrderToOrderGroupRequest
     */
    'deleteOrderFromOrderGroupInfo'?: DeleteOrderFromOrderGroupInfo;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * 仕向地全件取得APIのレスポンスで返す情報
 * @export
 * @interface GetDestinationNameResponse
 */
export interface GetDestinationNameResponse {
    /**
     * 
     * @type {number}
     * @memberof GetDestinationNameResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetDestinationNameResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetDestinationNameResponse
     */
    'message': string;
    /**
     * 
     * @type {GetDestinationNameResponseResult}
     * @memberof GetDestinationNameResponse
     */
    'result': GetDestinationNameResponseResult;
}
/**
 * 仕向地全件取得情報
 * @export
 * @interface GetDestinationNameResponseResult
 */
export interface GetDestinationNameResponseResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetDestinationNameResponseResult
     */
    'destinationNames': Array<string>;
}
/**
 * インボイス番号全件取得APIのレスポンスで返す情報
 * @export
 * @interface GetInvoiceNumberResponse
 */
export interface GetInvoiceNumberResponse {
    /**
     * 
     * @type {number}
     * @memberof GetInvoiceNumberResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetInvoiceNumberResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceNumberResponse
     */
    'message': string;
    /**
     * 
     * @type {GetInvoiceNumberResponseResult}
     * @memberof GetInvoiceNumberResponse
     */
    'result': GetInvoiceNumberResponseResult;
}
/**
 * インボイス番号全件取得情報
 * @export
 * @interface GetInvoiceNumberResponseResult
 */
export interface GetInvoiceNumberResponseResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetInvoiceNumberResponseResult
     */
    'invoiceNumbers': Array<string>;
}
/**
 * 発注グループ名全件取得APIのレスポンスで返す情報
 * @export
 * @interface GetOrderGroupNameResponse
 */
export interface GetOrderGroupNameResponse {
    /**
     * 
     * @type {number}
     * @memberof GetOrderGroupNameResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderGroupNameResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderGroupNameResponse
     */
    'message': string;
    /**
     * 
     * @type {GetOrderGroupNameResponseResult}
     * @memberof GetOrderGroupNameResponse
     */
    'result': GetOrderGroupNameResponseResult;
}
/**
 * 発注グループ名全件取得情報
 * @export
 * @interface GetOrderGroupNameResponseResult
 */
export interface GetOrderGroupNameResponseResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof GetOrderGroupNameResponseResult
     */
    'orderGroupNames': Array<string>;
}
/**
 * グループ情報取得レスポンスで返す情報
 * @export
 * @interface GetOrderGroupResponse
 */
export interface GetOrderGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof GetOrderGroupResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderGroupResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderGroupResponse
     */
    'message': string;
    /**
     * 
     * @type {GetOrderGroupResponseResult}
     * @memberof GetOrderGroupResponse
     */
    'result': GetOrderGroupResponseResult;
}
/**
 * グループ情報取得レスポンスで返す情報
 * @export
 * @interface GetOrderGroupResponseResult
 */
export interface GetOrderGroupResponseResult {
    /**
     * 
     * @type {Array<GetOrderGroupResponseResultData>}
     * @memberof GetOrderGroupResponseResult
     */
    'data': Array<GetOrderGroupResponseResultData>;
}
/**
 * グループ取得の個々の情報
 * @export
 * @interface GetOrderGroupResponseResultData
 */
export interface GetOrderGroupResponseResultData {
    /**
     * 発注グループID
     * @type {string}
     * @memberof GetOrderGroupResponseResultData
     */
    'orderGroupId': string;
    /**
     * 発注グループ名
     * @type {string}
     * @memberof GetOrderGroupResponseResultData
     */
    'orderGroupName': string;
    /**
     * 請求書番号
     * @type {string}
     * @memberof GetOrderGroupResponseResultData
     */
    'invoiceNumber': string;
    /**
     * 仕向先名
     * @type {string}
     * @memberof GetOrderGroupResponseResultData
     */
    'destinationName': string;
    /**
     * 上限数量
     * @type {number}
     * @memberof GetOrderGroupResponseResultData
     */
    'upperLimitQuantity': number;
    /**
     * メモ
     * @type {string}
     * @memberof GetOrderGroupResponseResultData
     */
    'memo': string;
    /**
     * 発注グループに紐付けされた発注の納期
     * @type {number}
     * @memberof GetOrderGroupResponseResultData
     */
    'eta': number | null;
    /**
     * 発注グループに紐づいている発注の数
     * @type {number}
     * @memberof GetOrderGroupResponseResultData
     */
    'linkedOrderCount': number;
    /**
     * 発注グループに紐づいている発注の合計数量
     * @type {number}
     * @memberof GetOrderGroupResponseResultData
     */
    'totalLinkedOrderAmount': number;
}
/**
 * グループ情報1件取得レスポンスで返す情報
 * @export
 * @interface GetSingleOrderGroupResponse
 */
export interface GetSingleOrderGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof GetSingleOrderGroupResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetSingleOrderGroupResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetSingleOrderGroupResponse
     */
    'message': string;
    /**
     * 
     * @type {GetSingleOrderGroupResponseResult}
     * @memberof GetSingleOrderGroupResponse
     */
    'result': GetSingleOrderGroupResponseResult;
}
/**
 * グループ情報取得レスポンスで返す情報
 * @export
 * @interface GetSingleOrderGroupResponseResult
 */
export interface GetSingleOrderGroupResponseResult {
    /**
     * 
     * @type {GetOrderGroupResponseResultData}
     * @memberof GetSingleOrderGroupResponseResult
     */
    'data': GetOrderGroupResponseResultData;
}
/**
 * 発注確定時にユーザーが操作した内示値
 * @export
 * @interface OrderBasisAdjustedCustomerForecast
 */
export interface OrderBasisAdjustedCustomerForecast {
    /**
     * 対象年
     * @type {number}
     * @memberof OrderBasisAdjustedCustomerForecast
     */
    'targetYear': number;
    /**
     * 対象月
     * @type {number}
     * @memberof OrderBasisAdjustedCustomerForecast
     */
    'targetMonth': number;
    /**
     * 発注確定時にユーザーが操作した客先内示の値
     * @type {string}
     * @memberof OrderBasisAdjustedCustomerForecast
     */
    'amount': string;
}
/**
 * 発注情報登録で渡す発注根拠情報の型定義
 * @export
 * @interface OrderBasisAdjustedInfo
 */
export interface OrderBasisAdjustedInfo {
    /**
     * 発注確定時にユーザーが操作したリードタイム（userAdjustedLeadTimeUnitに対応する値）
     * @type {number}
     * @memberof OrderBasisAdjustedInfo
     */
    'userAdjustedLeadTime'?: number;
    /**
     * 発注確定時にユーザーが操作したリードタイム単位
     * @type {string}
     * @memberof OrderBasisAdjustedInfo
     */
    'userAdjustedLeadTimeUnit'?: OrderBasisAdjustedInfoUserAdjustedLeadTimeUnitEnum;
    /**
     * 発注確定時にユーザーが操作した標準在庫指数最小値(単位に合わせた数値)
     * @type {number}
     * @memberof OrderBasisAdjustedInfo
     */
    'userAdjustedStdInventoryIndexMin'?: number;
    /**
     * 発注確定時にユーザーが操作した標準在庫指数最大値(単位に合わせた数値)
     * @type {number}
     * @memberof OrderBasisAdjustedInfo
     */
    'userAdjustedStdInventoryIndexMax'?: number;
    /**
     * 発注確定時にユーザーが操作した標準在庫指数単位
     * @type {string}
     * @memberof OrderBasisAdjustedInfo
     */
    'userAdjustedStdInventoryIndexUnit'?: OrderBasisAdjustedInfoUserAdjustedStdInventoryIndexUnitEnum;
    /**
     * 
     * @type {Array<OrderBasisAdjustedCustomerForecast>}
     * @memberof OrderBasisAdjustedInfo
     */
    'userAdjustedCustomerForecasts'?: Array<OrderBasisAdjustedCustomerForecast>;
}

export const OrderBasisAdjustedInfoUserAdjustedLeadTimeUnitEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month'
} as const;

export type OrderBasisAdjustedInfoUserAdjustedLeadTimeUnitEnum = typeof OrderBasisAdjustedInfoUserAdjustedLeadTimeUnitEnum[keyof typeof OrderBasisAdjustedInfoUserAdjustedLeadTimeUnitEnum];
export const OrderBasisAdjustedInfoUserAdjustedStdInventoryIndexUnitEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month'
} as const;

export type OrderBasisAdjustedInfoUserAdjustedStdInventoryIndexUnitEnum = typeof OrderBasisAdjustedInfoUserAdjustedStdInventoryIndexUnitEnum[keyof typeof OrderBasisAdjustedInfoUserAdjustedStdInventoryIndexUnitEnum];

/**
 * まとめ発注作成用の発注情報
 * @export
 * @interface OrderInfoForBulkOrderInfo
 */
export interface OrderInfoForBulkOrderInfo {
    /**
     * 発注ID
     * @type {string}
     * @memberof OrderInfoForBulkOrderInfo
     */
    'orderId': string;
    /**
     * 集計ID
     * @type {string}
     * @memberof OrderInfoForBulkOrderInfo
     */
    'aggregateBusinessId': string;
    /**
     * 表示ID
     * @type {string}
     * @memberof OrderInfoForBulkOrderInfo
     */
    'displayId': string;
    /**
     * 発注日時
     * @type {string}
     * @memberof OrderInfoForBulkOrderInfo
     */
    'createdOrderDate'?: string;
    /**
     * 希望納品日
     * @type {string}
     * @memberof OrderInfoForBulkOrderInfo
     */
    'desiredDeliveryDate': string;
    /**
     * 到着予定日時
     * @type {string}
     * @memberof OrderInfoForBulkOrderInfo
     */
    'estimatedTimeOfArrival': string;
    /**
     * 発注数量
     * @type {number}
     * @memberof OrderInfoForBulkOrderInfo
     */
    'orderAmount': number;
    /**
     * 発注ステータス
     * @type {string}
     * @memberof OrderInfoForBulkOrderInfo
     */
    'orderStatus': string;
    /**
     * 発注メモ
     * @type {string}
     * @memberof OrderInfoForBulkOrderInfo
     */
    'orderNote'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderInfoForBulkOrderInfo
     */
    'updateAt'?: number;
}
/**
 * 発注グループ作成用の情報
 * @export
 * @interface PostOrderGroupInfo
 */
export interface PostOrderGroupInfo {
    /**
     * まとめ発注グループ名
     * @type {string}
     * @memberof PostOrderGroupInfo
     */
    'orderGroupName': string;
    /**
     * 請求書番号
     * @type {string}
     * @memberof PostOrderGroupInfo
     */
    'invoiceNumber'?: string;
    /**
     * 仕向先名
     * @type {string}
     * @memberof PostOrderGroupInfo
     */
    'destinationName'?: string;
    /**
     * 上限数量
     * @type {number}
     * @memberof PostOrderGroupInfo
     */
    'upperLimitQuantity': number;
    /**
     * メモ
     * @type {string}
     * @memberof PostOrderGroupInfo
     */
    'memo'?: string;
}
/**
 * 
 * @export
 * @interface PostOrderGroupRequest
 */
export interface PostOrderGroupRequest {
    /**
     * 
     * @type {PostOrderGroupInfo}
     * @memberof PostOrderGroupRequest
     */
    'postOrderGroupInfo'?: PostOrderGroupInfo;
}
/**
 * 発注グループ情報登録レスポンスで返す情報
 * @export
 * @interface PostOrderGroupResponse
 */
export interface PostOrderGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof PostOrderGroupResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PostOrderGroupResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PostOrderGroupResponse
     */
    'message': string;
    /**
     * 
     * @type {PostOrderGroupResponseResult}
     * @memberof PostOrderGroupResponse
     */
    'result': PostOrderGroupResponseResult;
}
/**
 * 発注グループ情報登録レスポンスで返す情報
 * @export
 * @interface PostOrderGroupResponseResult
 */
export interface PostOrderGroupResponseResult {
    /**
     * 発注グループID
     * @type {string}
     * @memberof PostOrderGroupResponseResult
     */
    'orderGroupId'?: string;
}
/**
 * 発注グループに発注を紐づける情報
 * @export
 * @interface PostOrderToOrderGroupInfo
 */
export interface PostOrderToOrderGroupInfo {
    /**
     * 
     * @type {string}
     * @memberof PostOrderToOrderGroupInfo
     */
    'estimatedTimeOfArrival'?: string;
    /**
     * 
     * @type {PostOrderToOrderGroupInfoPostOrderToOrderGroupOrderInfo}
     * @memberof PostOrderToOrderGroupInfo
     */
    'postOrderToOrderGroupOrderInfo': PostOrderToOrderGroupInfoPostOrderToOrderGroupOrderInfo;
}
/**
 * 
 * @export
 * @interface PostOrderToOrderGroupInfoPostOrderToOrderGroupOrderInfo
 */
export interface PostOrderToOrderGroupInfoPostOrderToOrderGroupOrderInfo {
    /**
     * 発注グループID
     * @type {string}
     * @memberof PostOrderToOrderGroupInfoPostOrderToOrderGroupOrderInfo
     */
    'orderGroupId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PostOrderToOrderGroupInfoPostOrderToOrderGroupOrderInfo
     */
    'orderIds': Array<string>;
}
/**
 * 
 * @export
 * @interface PostOrderToOrderGroupRequest
 */
export interface PostOrderToOrderGroupRequest {
    /**
     * 
     * @type {PostOrderToOrderGroupInfo}
     * @memberof PostOrderToOrderGroupRequest
     */
    'postOrderToOrderGroupInfo'?: PostOrderToOrderGroupInfo;
}
/**
 * 発注グループに発注を紐づけるAPIのリクエスト情報
 * @export
 * @interface PostOrderToOrderGroupResponse
 */
export interface PostOrderToOrderGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof PostOrderToOrderGroupResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof PostOrderToOrderGroupResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof PostOrderToOrderGroupResponse
     */
    'message': string;
    /**
     * 
     * @type {PostOrderToOrderGroupResponseResult}
     * @memberof PostOrderToOrderGroupResponse
     */
    'result': PostOrderToOrderGroupResponseResult;
}
/**
 * 発注グループに発注を紐づけるAPIのリクエスト情報
 * @export
 * @interface PostOrderToOrderGroupResponseResult
 */
export interface PostOrderToOrderGroupResponseResult {
    /**
     * 発注グループID
     * @type {string}
     * @memberof PostOrderToOrderGroupResponseResult
     */
    'orderGroupId': string;
}
/**
 * 
 * @export
 * @interface PutOrderGroupRequest
 */
export interface PutOrderGroupRequest {
    /**
     * 納入予定日
     * @type {string}
     * @memberof PutOrderGroupRequest
     */
    'estimatedTimeOfArrival'?: string;
    /**
     * 
     * @type {UpdateOrderGroupInfo}
     * @memberof PutOrderGroupRequest
     */
    'updateOrderGroupInfo'?: UpdateOrderGroupInfo;
}
/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}
/**
 * 発注グループ更新用の情報
 * @export
 * @interface UpdateOrderGroupInfo
 */
export interface UpdateOrderGroupInfo {
    /**
     * まとめ発注グループ名
     * @type {string}
     * @memberof UpdateOrderGroupInfo
     */
    'orderGroupName': string;
    /**
     * 請求書番号
     * @type {string}
     * @memberof UpdateOrderGroupInfo
     */
    'invoiceNumber'?: string;
    /**
     * 仕向先名
     * @type {string}
     * @memberof UpdateOrderGroupInfo
     */
    'destinationName'?: string;
    /**
     * 上限数量
     * @type {number}
     * @memberof UpdateOrderGroupInfo
     */
    'upperLimitQuantity': number;
    /**
     * メモ
     * @type {string}
     * @memberof UpdateOrderGroupInfo
     */
    'memo'?: string;
}
/**
 * 発注グループ情報更新レスポンスで返す情報
 * @export
 * @interface UpdateOrderGroupResponse
 */
export interface UpdateOrderGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof UpdateOrderGroupResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOrderGroupResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderGroupResponse
     */
    'message': string;
    /**
     * 
     * @type {UpdateOrderGroupResponseResult}
     * @memberof UpdateOrderGroupResponse
     */
    'result': UpdateOrderGroupResponseResult;
}
/**
 * 発注グループ情報更新レスポンスで返す情報
 * @export
 * @interface UpdateOrderGroupResponseResult
 */
export interface UpdateOrderGroupResponseResult {
    /**
     * 発注グループID
     * @type {string}
     * @memberof UpdateOrderGroupResponseResult
     */
    'orderGroupId'?: string;
    /**
     * 納期変更で発注を更新した時に、そのupdateAtを返す(発注編集時に自分の変更で取引重複エラーが出てしまうため)
     * @type {number}
     * @memberof UpdateOrderGroupResponseResult
     */
    'orderUpdateAt'?: number;
}

/**
 * CreateBulkOrderApi - axios parameter creator
 * @export
 */
export const CreateBulkOrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary まとめ発注の作成
         * @param {CreateBulkOrderRequest} createBulkOrderRequest まとめ発注作成用の発注情報と発注グループ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkOrder: async (createBulkOrderRequest: CreateBulkOrderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBulkOrderRequest' is not null or undefined
            assertParamExists('createBulkOrder', 'createBulkOrderRequest', createBulkOrderRequest)
            const localVarPath = `/create-bulk-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBulkOrderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CreateBulkOrderApi - functional programming interface
 * @export
 */
export const CreateBulkOrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CreateBulkOrderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary まとめ発注の作成
         * @param {CreateBulkOrderRequest} createBulkOrderRequest まとめ発注作成用の発注情報と発注グループ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBulkOrder(createBulkOrderRequest: CreateBulkOrderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateBulkOrderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBulkOrder(createBulkOrderRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CreateBulkOrderApi.createBulkOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CreateBulkOrderApi - factory interface
 * @export
 */
export const CreateBulkOrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CreateBulkOrderApiFp(configuration)
    return {
        /**
         * 
         * @summary まとめ発注の作成
         * @param {CreateBulkOrderRequest} createBulkOrderRequest まとめ発注作成用の発注情報と発注グループ情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkOrder(createBulkOrderRequest: CreateBulkOrderRequest, options?: any): AxiosPromise<CreateBulkOrderResponse> {
            return localVarFp.createBulkOrder(createBulkOrderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CreateBulkOrderApi - object-oriented interface
 * @export
 * @class CreateBulkOrderApi
 * @extends {BaseAPI}
 */
export class CreateBulkOrderApi extends BaseAPI {
    /**
     * 
     * @summary まとめ発注の作成
     * @param {CreateBulkOrderRequest} createBulkOrderRequest まとめ発注作成用の発注情報と発注グループ情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreateBulkOrderApi
     */
    public createBulkOrder(createBulkOrderRequest: CreateBulkOrderRequest, options?: RawAxiosRequestConfig) {
        return CreateBulkOrderApiFp(this.configuration).createBulkOrder(createBulkOrderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DestinationNameApi - axios parameter creator
 * @export
 */
export const DestinationNameApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 仕向地を全件取得
         * @param {string} [orderGroupName] 発注グループ名
         * @param {string} [invoiceNumber] インボイス番号
         * @param {string} [keyWord] キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinationName: async (orderGroupName?: string, invoiceNumber?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/destination-name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderGroupName !== undefined) {
                localVarQueryParameter['orderGroupName'] = orderGroupName;
            }

            if (invoiceNumber !== undefined) {
                localVarQueryParameter['invoiceNumber'] = invoiceNumber;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DestinationNameApi - functional programming interface
 * @export
 */
export const DestinationNameApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DestinationNameApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 仕向地を全件取得
         * @param {string} [orderGroupName] 発注グループ名
         * @param {string} [invoiceNumber] インボイス番号
         * @param {string} [keyWord] キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDestinationName(orderGroupName?: string, invoiceNumber?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDestinationNameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDestinationName(orderGroupName, invoiceNumber, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DestinationNameApi.getDestinationName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DestinationNameApi - factory interface
 * @export
 */
export const DestinationNameApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DestinationNameApiFp(configuration)
    return {
        /**
         * 
         * @summary 仕向地を全件取得
         * @param {string} [orderGroupName] 発注グループ名
         * @param {string} [invoiceNumber] インボイス番号
         * @param {string} [keyWord] キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinationName(orderGroupName?: string, invoiceNumber?: string, keyWord?: string, options?: any): AxiosPromise<GetDestinationNameResponse> {
            return localVarFp.getDestinationName(orderGroupName, invoiceNumber, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DestinationNameApi - object-oriented interface
 * @export
 * @class DestinationNameApi
 * @extends {BaseAPI}
 */
export class DestinationNameApi extends BaseAPI {
    /**
     * 
     * @summary 仕向地を全件取得
     * @param {string} [orderGroupName] 発注グループ名
     * @param {string} [invoiceNumber] インボイス番号
     * @param {string} [keyWord] キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DestinationNameApi
     */
    public getDestinationName(orderGroupName?: string, invoiceNumber?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return DestinationNameApiFp(this.configuration).getDestinationName(orderGroupName, invoiceNumber, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvoiceNumberApi - axios parameter creator
 * @export
 */
export const InvoiceNumberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary インボイス番号を全件取得
         * @param {string} [orderGroupName] 発注グループ名
         * @param {string} [destinationName] 仕向先
         * @param {string} [keyWord] キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceNumber: async (orderGroupName?: string, destinationName?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/invoice-number`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderGroupName !== undefined) {
                localVarQueryParameter['orderGroupName'] = orderGroupName;
            }

            if (destinationName !== undefined) {
                localVarQueryParameter['destinationName'] = destinationName;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoiceNumberApi - functional programming interface
 * @export
 */
export const InvoiceNumberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoiceNumberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary インボイス番号を全件取得
         * @param {string} [orderGroupName] 発注グループ名
         * @param {string} [destinationName] 仕向先
         * @param {string} [keyWord] キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvoiceNumber(orderGroupName?: string, destinationName?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInvoiceNumberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvoiceNumber(orderGroupName, destinationName, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceNumberApi.getInvoiceNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoiceNumberApi - factory interface
 * @export
 */
export const InvoiceNumberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoiceNumberApiFp(configuration)
    return {
        /**
         * 
         * @summary インボイス番号を全件取得
         * @param {string} [orderGroupName] 発注グループ名
         * @param {string} [destinationName] 仕向先
         * @param {string} [keyWord] キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvoiceNumber(orderGroupName?: string, destinationName?: string, keyWord?: string, options?: any): AxiosPromise<GetInvoiceNumberResponse> {
            return localVarFp.getInvoiceNumber(orderGroupName, destinationName, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoiceNumberApi - object-oriented interface
 * @export
 * @class InvoiceNumberApi
 * @extends {BaseAPI}
 */
export class InvoiceNumberApi extends BaseAPI {
    /**
     * 
     * @summary インボイス番号を全件取得
     * @param {string} [orderGroupName] 発注グループ名
     * @param {string} [destinationName] 仕向先
     * @param {string} [keyWord] キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceNumberApi
     */
    public getInvoiceNumber(orderGroupName?: string, destinationName?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return InvoiceNumberApiFp(this.configuration).getInvoiceNumber(orderGroupName, destinationName, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderGroupApi - axios parameter creator
 * @export
 */
export const OrderGroupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 発注グループの削除
         * @param {string} orderGroupId 発注グループID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrderGroup: async (orderGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderGroupId' is not null or undefined
            assertParamExists('deleteOrderGroup', 'orderGroupId', orderGroupId)
            const localVarPath = `/order-group/{order_group_id}`
                .replace(`{${"order_group_id"}}`, encodeURIComponent(String(orderGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 発注グループの一覧取得
         * @param {string} [keyWord] キーワード（発注グループ名）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderGroup: async (keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 指定した発注グループの取得
         * @param {string} orderGroupId 発注グループID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSingleOrderGroup: async (orderGroupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderGroupId' is not null or undefined
            assertParamExists('getSingleOrderGroup', 'orderGroupId', orderGroupId)
            const localVarPath = `/order-group/{order_group_id}`
                .replace(`{${"order_group_id"}}`, encodeURIComponent(String(orderGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 発注グループの作成
         * @param {PostOrderGroupRequest} postOrderGroupRequest 発注グループ作成用の情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOrderGroup: async (postOrderGroupRequest: PostOrderGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postOrderGroupRequest' is not null or undefined
            assertParamExists('postOrderGroup', 'postOrderGroupRequest', postOrderGroupRequest)
            const localVarPath = `/order-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postOrderGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 発注グループの更新
         * @param {string} orderGroupId 発注グループID
         * @param {PutOrderGroupRequest} putOrderGroupRequest 発注グループ情報の更新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOrderGroup: async (orderGroupId: string, putOrderGroupRequest: PutOrderGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderGroupId' is not null or undefined
            assertParamExists('putOrderGroup', 'orderGroupId', orderGroupId)
            // verify required parameter 'putOrderGroupRequest' is not null or undefined
            assertParamExists('putOrderGroup', 'putOrderGroupRequest', putOrderGroupRequest)
            const localVarPath = `/order-group/{order_group_id}`
                .replace(`{${"order_group_id"}}`, encodeURIComponent(String(orderGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putOrderGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderGroupApi - functional programming interface
 * @export
 */
export const OrderGroupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderGroupApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 発注グループの削除
         * @param {string} orderGroupId 発注グループID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrderGroup(orderGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteOrderGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrderGroup(orderGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderGroupApi.deleteOrderGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 発注グループの一覧取得
         * @param {string} [keyWord] キーワード（発注グループ名）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderGroup(keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderGroup(keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderGroupApi.getOrderGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 指定した発注グループの取得
         * @param {string} orderGroupId 発注グループID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSingleOrderGroup(orderGroupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSingleOrderGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSingleOrderGroup(orderGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderGroupApi.getSingleOrderGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 発注グループの作成
         * @param {PostOrderGroupRequest} postOrderGroupRequest 発注グループ作成用の情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postOrderGroup(postOrderGroupRequest: PostOrderGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostOrderGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postOrderGroup(postOrderGroupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderGroupApi.postOrderGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 発注グループの更新
         * @param {string} orderGroupId 発注グループID
         * @param {PutOrderGroupRequest} putOrderGroupRequest 発注グループ情報の更新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putOrderGroup(orderGroupId: string, putOrderGroupRequest: PutOrderGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOrderGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putOrderGroup(orderGroupId, putOrderGroupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderGroupApi.putOrderGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderGroupApi - factory interface
 * @export
 */
export const OrderGroupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderGroupApiFp(configuration)
    return {
        /**
         * 
         * @summary 発注グループの削除
         * @param {string} orderGroupId 発注グループID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrderGroup(orderGroupId: string, options?: any): AxiosPromise<DeleteOrderGroupResponse> {
            return localVarFp.deleteOrderGroup(orderGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 発注グループの一覧取得
         * @param {string} [keyWord] キーワード（発注グループ名）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderGroup(keyWord?: string, options?: any): AxiosPromise<GetOrderGroupResponse> {
            return localVarFp.getOrderGroup(keyWord, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 指定した発注グループの取得
         * @param {string} orderGroupId 発注グループID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSingleOrderGroup(orderGroupId: string, options?: any): AxiosPromise<GetSingleOrderGroupResponse> {
            return localVarFp.getSingleOrderGroup(orderGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 発注グループの作成
         * @param {PostOrderGroupRequest} postOrderGroupRequest 発注グループ作成用の情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOrderGroup(postOrderGroupRequest: PostOrderGroupRequest, options?: any): AxiosPromise<PostOrderGroupResponse> {
            return localVarFp.postOrderGroup(postOrderGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 発注グループの更新
         * @param {string} orderGroupId 発注グループID
         * @param {PutOrderGroupRequest} putOrderGroupRequest 発注グループ情報の更新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putOrderGroup(orderGroupId: string, putOrderGroupRequest: PutOrderGroupRequest, options?: any): AxiosPromise<UpdateOrderGroupResponse> {
            return localVarFp.putOrderGroup(orderGroupId, putOrderGroupRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderGroupApi - object-oriented interface
 * @export
 * @class OrderGroupApi
 * @extends {BaseAPI}
 */
export class OrderGroupApi extends BaseAPI {
    /**
     * 
     * @summary 発注グループの削除
     * @param {string} orderGroupId 発注グループID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderGroupApi
     */
    public deleteOrderGroup(orderGroupId: string, options?: RawAxiosRequestConfig) {
        return OrderGroupApiFp(this.configuration).deleteOrderGroup(orderGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 発注グループの一覧取得
     * @param {string} [keyWord] キーワード（発注グループ名）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderGroupApi
     */
    public getOrderGroup(keyWord?: string, options?: RawAxiosRequestConfig) {
        return OrderGroupApiFp(this.configuration).getOrderGroup(keyWord, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 指定した発注グループの取得
     * @param {string} orderGroupId 発注グループID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderGroupApi
     */
    public getSingleOrderGroup(orderGroupId: string, options?: RawAxiosRequestConfig) {
        return OrderGroupApiFp(this.configuration).getSingleOrderGroup(orderGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 発注グループの作成
     * @param {PostOrderGroupRequest} postOrderGroupRequest 発注グループ作成用の情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderGroupApi
     */
    public postOrderGroup(postOrderGroupRequest: PostOrderGroupRequest, options?: RawAxiosRequestConfig) {
        return OrderGroupApiFp(this.configuration).postOrderGroup(postOrderGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 発注グループの更新
     * @param {string} orderGroupId 発注グループID
     * @param {PutOrderGroupRequest} putOrderGroupRequest 発注グループ情報の更新
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderGroupApi
     */
    public putOrderGroup(orderGroupId: string, putOrderGroupRequest: PutOrderGroupRequest, options?: RawAxiosRequestConfig) {
        return OrderGroupApiFp(this.configuration).putOrderGroup(orderGroupId, putOrderGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderGroupNameApi - axios parameter creator
 * @export
 */
export const OrderGroupNameApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 発注グループ名を全件取得
         * @param {string} [invoiceNumber] インボイス番号
         * @param {string} [destinationName] 仕向先
         * @param {string} [keyWord] キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderGroupName: async (invoiceNumber?: string, destinationName?: string, keyWord?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order-group-name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (invoiceNumber !== undefined) {
                localVarQueryParameter['invoiceNumber'] = invoiceNumber;
            }

            if (destinationName !== undefined) {
                localVarQueryParameter['destinationName'] = destinationName;
            }

            if (keyWord !== undefined) {
                localVarQueryParameter['keyWord'] = keyWord;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderGroupNameApi - functional programming interface
 * @export
 */
export const OrderGroupNameApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderGroupNameApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 発注グループ名を全件取得
         * @param {string} [invoiceNumber] インボイス番号
         * @param {string} [destinationName] 仕向先
         * @param {string} [keyWord] キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderGroupName(invoiceNumber?: string, destinationName?: string, keyWord?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderGroupNameResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderGroupName(invoiceNumber, destinationName, keyWord, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderGroupNameApi.getOrderGroupName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderGroupNameApi - factory interface
 * @export
 */
export const OrderGroupNameApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderGroupNameApiFp(configuration)
    return {
        /**
         * 
         * @summary 発注グループ名を全件取得
         * @param {string} [invoiceNumber] インボイス番号
         * @param {string} [destinationName] 仕向先
         * @param {string} [keyWord] キーワード
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderGroupName(invoiceNumber?: string, destinationName?: string, keyWord?: string, options?: any): AxiosPromise<GetOrderGroupNameResponse> {
            return localVarFp.getOrderGroupName(invoiceNumber, destinationName, keyWord, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderGroupNameApi - object-oriented interface
 * @export
 * @class OrderGroupNameApi
 * @extends {BaseAPI}
 */
export class OrderGroupNameApi extends BaseAPI {
    /**
     * 
     * @summary 発注グループ名を全件取得
     * @param {string} [invoiceNumber] インボイス番号
     * @param {string} [destinationName] 仕向先
     * @param {string} [keyWord] キーワード
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderGroupNameApi
     */
    public getOrderGroupName(invoiceNumber?: string, destinationName?: string, keyWord?: string, options?: RawAxiosRequestConfig) {
        return OrderGroupNameApiFp(this.configuration).getOrderGroupName(invoiceNumber, destinationName, keyWord, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderToOrderGroupApi - axios parameter creator
 * @export
 */
export const OrderToOrderGroupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 発注をまとめ発注から外す
         * @param {DeleteOrderToOrderGroupRequest} deleteOrderToOrderGroupRequest 発注をまとめ発注から外すための情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrderToOrderGroup: async (deleteOrderToOrderGroupRequest: DeleteOrderToOrderGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteOrderToOrderGroupRequest' is not null or undefined
            assertParamExists('deleteOrderToOrderGroup', 'deleteOrderToOrderGroupRequest', deleteOrderToOrderGroupRequest)
            const localVarPath = `/order-to-order-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteOrderToOrderGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 発注をまとめ発注に紐づける
         * @param {PostOrderToOrderGroupRequest} postOrderToOrderGroupRequest 発注をまとめ発注に紐づけるための情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOrderToOrderGroup: async (postOrderToOrderGroupRequest: PostOrderToOrderGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postOrderToOrderGroupRequest' is not null or undefined
            assertParamExists('postOrderToOrderGroup', 'postOrderToOrderGroupRequest', postOrderToOrderGroupRequest)
            const localVarPath = `/order-to-order-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postOrderToOrderGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderToOrderGroupApi - functional programming interface
 * @export
 */
export const OrderToOrderGroupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderToOrderGroupApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 発注をまとめ発注から外す
         * @param {DeleteOrderToOrderGroupRequest} deleteOrderToOrderGroupRequest 発注をまとめ発注から外すための情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrderToOrderGroup(deleteOrderToOrderGroupRequest: DeleteOrderToOrderGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteOrderFromOrderGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrderToOrderGroup(deleteOrderToOrderGroupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderToOrderGroupApi.deleteOrderToOrderGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 発注をまとめ発注に紐づける
         * @param {PostOrderToOrderGroupRequest} postOrderToOrderGroupRequest 発注をまとめ発注に紐づけるための情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postOrderToOrderGroup(postOrderToOrderGroupRequest: PostOrderToOrderGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PostOrderToOrderGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postOrderToOrderGroup(postOrderToOrderGroupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrderToOrderGroupApi.postOrderToOrderGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrderToOrderGroupApi - factory interface
 * @export
 */
export const OrderToOrderGroupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderToOrderGroupApiFp(configuration)
    return {
        /**
         * 
         * @summary 発注をまとめ発注から外す
         * @param {DeleteOrderToOrderGroupRequest} deleteOrderToOrderGroupRequest 発注をまとめ発注から外すための情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrderToOrderGroup(deleteOrderToOrderGroupRequest: DeleteOrderToOrderGroupRequest, options?: any): AxiosPromise<DeleteOrderFromOrderGroupResponse> {
            return localVarFp.deleteOrderToOrderGroup(deleteOrderToOrderGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 発注をまとめ発注に紐づける
         * @param {PostOrderToOrderGroupRequest} postOrderToOrderGroupRequest 発注をまとめ発注に紐づけるための情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postOrderToOrderGroup(postOrderToOrderGroupRequest: PostOrderToOrderGroupRequest, options?: any): AxiosPromise<PostOrderToOrderGroupResponse> {
            return localVarFp.postOrderToOrderGroup(postOrderToOrderGroupRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderToOrderGroupApi - object-oriented interface
 * @export
 * @class OrderToOrderGroupApi
 * @extends {BaseAPI}
 */
export class OrderToOrderGroupApi extends BaseAPI {
    /**
     * 
     * @summary 発注をまとめ発注から外す
     * @param {DeleteOrderToOrderGroupRequest} deleteOrderToOrderGroupRequest 発注をまとめ発注から外すための情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderToOrderGroupApi
     */
    public deleteOrderToOrderGroup(deleteOrderToOrderGroupRequest: DeleteOrderToOrderGroupRequest, options?: RawAxiosRequestConfig) {
        return OrderToOrderGroupApiFp(this.configuration).deleteOrderToOrderGroup(deleteOrderToOrderGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 発注をまとめ発注に紐づける
     * @param {PostOrderToOrderGroupRequest} postOrderToOrderGroupRequest 発注をまとめ発注に紐づけるための情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderToOrderGroupApi
     */
    public postOrderToOrderGroup(postOrderToOrderGroupRequest: PostOrderToOrderGroupRequest, options?: RawAxiosRequestConfig) {
        return OrderToOrderGroupApiFp(this.configuration).postOrderToOrderGroup(postOrderToOrderGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



